import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import MissionHero from './components/MissionHero';
import CompanyTimeline from './components/CompanyTimeline';
import CoreValues from './components/CoreValues';
import DevelopmentApproach from './components/DevelopmentApproach';
import PricingPhilosophy from './components/PricingPhilosophy';
import SocialProof from './components/SocialProof';
import TransitionToTeam from './components/TransitionToTeam';

const AboutMissionValues = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>About Byte Pairs | Mission, Values & Software Development Philosophy</title>
        <meta
          name="description"
          content="Discover Byte Pairs' mission to democratize premium digital experiences. Learn about our values, development approach, and commitment to delivering custom billing, ERP, and booking software tools."
        />
        <meta name="keywords" content="about bytepairs, mission, values, development approach, pricing philosophy, digital solutions, web development company, software company Dharapuram" />
        <meta property="og:title" content="About Byte Pairs | Mission, Values & Software Development Philosophy" />
        <meta property="og:description" content="Discover Byte Pairs' mission to deliver custom billing, ERP, and booking software tools with transparency, honest pricing, and direct developer communication." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://bytepairs.com/about-mission-values" />
        <link rel="canonical" href="https://bytepairs.com/about-mission-values" />

        {/* AboutPage Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "About Byte Pairs | Mission, Values & Software Development Philosophy",
            "description": "Discover Byte Pairs' mission to build custom billing, ERP, CRM and booking software tools with transparency, honest pricing, and direct developer communication.",
            "url": "https://bytepairs.com/about-mission-values",
            "mainEntity": {
              "@type": "LocalBusiness",
              "name": "Byte Pairs",
              "url": "https://bytepairs.com/"
            }
          })}
        </script>

        {/* BreadcrumbList Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://bytepairs.com/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "About Us",
                "item": "https://bytepairs.com/about-mission-values"
              }
            ]
          })}
        </script>
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />

        <main className="pt-16">
          <MissionHero />
          <CompanyTimeline />
          <CoreValues />
          <DevelopmentApproach />
          <PricingPhilosophy />
          <SocialProof />
          <TransitionToTeam />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default AboutMissionValues;